import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../styles/Navigation.css';

const Navigation = ({ isOpen, onClose }) => {
  const { canRead, hasPermission, isAdmin } = useAuth();

  const navSections = [];

  // Main Section
  const mainItems = [];
  if (canRead('enquiries') || isAdmin()) {
    mainItems.push({ path: '/enquiries', label: 'Enquiries', icon: '📝' });
  }
  if (canRead('analytics') || isAdmin()) {
    mainItems.push({ path: '/analytics', label: 'Analytics', icon: '📊' });
  }
  if (canRead('clients') || isAdmin()) {
    mainItems.push({ path: '/clients', label: 'Clients', icon: '👥' });
  }
  if (canRead('transactions') || isAdmin()) {
    mainItems.push({ path: '/transactions', label: 'Transactions', icon: '💰' });
  }
  if (hasPermission('users.manage_hierarchy') || isAdmin()) {
    mainItems.push({ path: '/hierarchy', label: 'Hierarchy', icon: '🔗' });
  }

  if (mainItems.length > 0) {
    navSections.push({ title: 'Main', items: mainItems });
  }

  // Admin Section
  if (isAdmin()) {
    const adminItems = [
      { path: '/services', label: 'Services', icon: '🔧' },
      { path: '/roles', label: 'Roles', icon: '👔' },
      { path: '/permissions', label: 'Permissions', icon: '🔑' },
      { path: '/user-hierarchy', label: 'User Hierarchy', icon: '🏗️' },
      { path: '/form-configs', label: 'Form Configs', icon: '📋' },
      { path: '/key-rotation', label: 'Key Rotation', icon: '🔐' },
      { path: '/admin', label: 'Admin Panel', icon: '⚙️' }
    ];
    navSections.push({ title: 'Administration', items: adminItems });
  }

  const handleLinkClick = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <nav className={`page-nav ${isOpen ? 'open' : ''}`}>
      <div className="nav-content">
        {navSections.map((section) => (
          <div key={section.title} className="nav-section">
            <div className="nav-section-title">{section.title}</div>
            {section.items.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                onClick={handleLinkClick}
                className={({ isActive }) =>
                  isActive ? 'nav-link active' : 'nav-link'
                }
              >
                <span className="nav-icon">{item.icon}</span>
                <span className="nav-label">{item.label}</span>
              </NavLink>
            ))}
          </div>
        ))}
      </div>
    </nav>
  );
};

export default Navigation;

